import User from '@/app-core/api/endpoint/User'
import Rating from '@/app-core/api/endpoint/Rating'
import Tag from '@/app-core/api/endpoint/Tag'
import Store from '@/app-core/api/endpoint/Store'
import Config from '@/app-core/api/endpoint/Config'
import Cart from '@/app-core/api/endpoint/Cart'
import Checkout from '@/app-core/api/endpoint/Checkout'
import Account from '@/app-core/api/endpoint/Account'
import Contact from '@/app-core/api/endpoint/Contact'
import Otp from '@/app-core/api/endpoint/Otp'

export default {
  Otp     : Otp,
  Contact : Contact,
  Rating  : Rating,
  Tag     : Tag,
  Store   : Store,
  User    : User,
  Config  : Config,
  Cart    : Cart,
  Checkout: Checkout,
  Account : Account
}
